import { render, staticRenderFns } from "./ObjSelect.vue?vue&type=template&id=3603a678&scoped=true&"
import script from "./ObjSelect.vue?vue&type=script&lang=js&"
export * from "./ObjSelect.vue?vue&type=script&lang=js&"
import style0 from "./ObjSelect.vue?vue&type=style&index=0&id=3603a678&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3603a678",
  null
  
)

export default component.exports